<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("shortlink module settings") }}
      </h1>
    </div>

    <!-- Configuraciones específicas del módulo -->
    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("general_settings") }}</h1>

        <!-- Checkbox para auto-copiar al portapapeles -->
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_auto_copy"
            v-model="meta.auto_copy_to_clipboard"
          />
          <label for="chk_auto_copy">{{ $t("auto copy to clipboard") }}</label>
        </div>

        <!-- Perfil por defecto -->
        <div class="field">
          <label class="label">{{ $t("default profile") }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="meta.default_profile_uuid">
                <option value="">{{ $t("select profile") }}</option>
                <option
                  v-for="profile in profiles"
                  :key="profile.uuid"
                  :value="profile.uuid"
                >
                  {{ profile.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Expiración por defecto -->
        <div class="field">
          <label class="label">{{ $t("default expiration") }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="meta.default_expiration">
                <option value="">{{ $t("never") }}</option>
                <option value="1">1 {{ $t("day") }}</option>
                <option value="7">7 {{ $t("days") }}</option>
                <option value="30">30 {{ $t("days") }}</option>
                <option value="365">365 {{ $t("days") }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="buttons mt-5">
          <button
            class="button is-primary"
            @click="save"
            :class="{ 'is-loading': saving }"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  error_message,
  success_message,
  save_configuration,
  get_configuration,
} from "@/utils";

export default {
  name: "ShortlinkSettings",
  data() {
    return {
      meta: {
        auto_copy_to_clipboard: true,
        default_profile_uuid: "",
        default_expiration: "",
      },
      profiles: [],
      saving: false,
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("settings saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  mounted() {},
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) v.meta = conf;

        // if (conf && conf.drive_id)
        //   v.$refs.drive_dropdown.set_value(conf.drive_id);
        // if (conf && conf.renap_profile_id)
        //   v.$refs.renap_profile_dropdown.set_value(conf.renap_profile_id);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style scoped>
.is-checkradio + label {
  margin-left: 0.5rem;
}
</style>
